import axios from 'axios';
import { getURL } from './endpoints';

export const PRODUCTION_BASE_URL = window.location.origin;
export const DEVELOPMENT_BASE_URL = 'http://localhost:8888/mocks';

export const DEFAULT_PREFIX = '/hix';

export default class BaseService {
    constructor(config = {}){
        this.client = axios.create(config);
        this.client.defaults.headers.common['X-CSRF-TOKEN'] = global.csrf_token;
        this.client.interceptors.request.use(this.processRequest);
    }

    processRequest = (...args) => {

        const [ request ] = args;

        const {
            prefix = DEFAULT_PREFIX,
            replacements = {},
            url
        } = request;

        const baseURL = global.__ENV__.PRODUCTION
            ? PRODUCTION_BASE_URL + prefix
            : DEVELOPMENT_BASE_URL;

        const changeMethod = ({ method }) => {
            return typeof method === 'string' && method.toLowerCase() !== 'get' && global.__ENV__.DEVELOPMENT
                ? { method: 'get' }
                : { method };
        };

        return {
            ...request,
            ...changeMethod(request),
            baseURL,
            url: getURL(url, replacements)
        };
    };
}